import React, { useEffect, useState, useCallback } from 'react';
import * as api from '../api';

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, limit: 100, offset: 0 });
  const [loading, setLoading] = useState(true);
  const [actionFilter, setActionFilter] = useState('');

  const fetchLogs = useCallback(async (offset = 0) => {
    setLoading(true);
    try {
      const params = { limit: '100', offset: String(offset) };
      if (actionFilter) params.action = actionFilter;
      const data = await api.getAuditLogs(params);
      setLogs(data.logs);
      setPagination(data.pagination);
    } catch { /* ignore */ } finally { setLoading(false); }
  }, [actionFilter]);

  useEffect(() => { fetchLogs(0); }, [fetchLogs]);

  return (
    <div>
      <div className="page-header">
        <h1>Audit Log</h1>
        <p>All significant platform actions</p>
      </div>

      <div className="toolbar">
        <select className="filter-select" value={actionFilter} onChange={(e) => setActionFilter(e.target.value)}>
          <option value="">All actions</option>
          <option value="user.login">Login</option>
          <option value="user.register">Register</option>
          <option value="user.update">User Update</option>
          <option value="admin.login">Admin Login</option>
          <option value="admin.user.update">Admin User Update</option>
          <option value="admin.post.moderate">Post Moderation</option>
          <option value="admin.email.reply">Email Reply</option>
        </select>
      </div>

      {loading ? (
        <div className="loading">Loading audit logs...</div>
      ) : logs.length === 0 ? (
        <div className="empty-state"><p>No audit logs found.</p></div>
      ) : (
        <>
          <div className="card">
            <div className="table-container">
              <table>
                <thead>
                  <tr><th>Action</th><th>Actor</th><th>Resource</th><th>Details</th><th>IP</th><th>Time</th></tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id}>
                      <td><span className="badge badge-blue">{log.action}</span></td>
                      <td style={{ fontSize: 13 }}>{log.actorEmail || log.actorId || '—'}</td>
                      <td style={{ fontSize: 13 }}>
                        {log.resourceType ? `${log.resourceType}/${log.resourceId?.slice(0, 12)}...` : '—'}
                      </td>
                      <td style={{ fontSize: 12, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {log.details ? JSON.stringify(log.details) : '—'}
                      </td>
                      <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{log.ipAddress || '—'}</td>
                      <td style={{ fontSize: 13, color: '#888', whiteSpace: 'nowrap' }}>
                        {new Date(log.createdAt).toLocaleString('en-ZA')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination">
            <span>Showing {pagination.offset + 1}–{Math.min(pagination.offset + pagination.limit, pagination.total)} of {pagination.total}</span>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-secondary btn-sm" disabled={pagination.offset === 0} onClick={() => fetchLogs(Math.max(0, pagination.offset - pagination.limit))}>Previous</button>
              <button className="btn btn-secondary btn-sm" disabled={!pagination.hasMore} onClick={() => fetchLogs(pagination.offset + pagination.limit)}>Next</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
